import { Fragment, useState } from 'react';

import { ISectionModel } from 'Types/Litium';
import DividerWide from 'Components/DividerWide';
import DropdownArrow from 'Components/DropDownArrow';
import Markup from 'Components/Markup';

const ListSection = ({ listSection }: { listSection: ISectionModel[] }) => {
    const [openIndex, setOpenIndex] = useState(-1);

    return (
        <div
            style={
                {
                    '--box-width-desktop': '996px',
                } as React.CSSProperties
            }
            className="flex flex-col pb-2 pt-6 lg:pb-8 lg:pt-10"
        >
            <div className="hidden lg:flex">
                <DividerWide />
            </div>
            <ul className="grid w-full grid-cols-1 justify-center px-4.5 pb-3 pt-6 lg:grid-cols-[repeat(4,_minmax(_min-content,_250px))] lg:gap-5">
                <li className="lg:hidden">
                    <DividerWide />
                </li>
                {listSection.map((item, index) => (
                    <Fragment key={index}>
                        {(item.links?.findIndex(
                            link => link.href?.length > 0
                        ) >= 0 ||
                            item.text?.value?.length > 0) && (
                            <>
                                <li className="mb-2 mt-4 lg:my-0">
                                    <p className="mb-2 hidden w-full font-montserrat text-lg font-bold lg:block">
                                        {item.title}
                                    </p>
                                    <button
                                        onClick={() =>
                                            setOpenIndex(prevOpenIndex =>
                                                prevOpenIndex === index
                                                    ? -1
                                                    : index
                                            )
                                        }
                                        className="flex w-full items-center justify-between font-montserrat text-sm font-semibold lg:hidden"
                                    >
                                        {item.title}
                                        <span className="block h-4 w-4 lg:hidden">
                                            <DropdownArrow
                                                showPlus={index === openIndex}
                                            />
                                        </span>
                                    </button>
                                    <div
                                        className={`mt-2 grid overflow-hidden transition-all duration-layout ${
                                            index === openIndex
                                                ? 'visible grid-rows-[1fr]'
                                                : 'invisible grid-rows-[0fr]'
                                        } lg:visible lg:mt-0 lg:block`}
                                    >
                                        <ul className="ml-0.5 overflow-hidden lg:mt-0">
                                            {item.links.map(
                                                (subItem, subIndex: number) =>
                                                    subItem.href && (
                                                        <li
                                                            className="mb-2"
                                                            key={subIndex}
                                                        >
                                                            <a
                                                                className="font-roboto text-sm hover:underline"
                                                                href={
                                                                    subItem.href
                                                                }
                                                            >
                                                                {subItem.text}
                                                            </a>
                                                        </li>
                                                    )
                                            )}
                                            {item.text && (
                                                <Markup
                                                    html={item.text?.value}
                                                    as="li"
                                                />
                                            )}
                                        </ul>
                                    </div>
                                </li>
                                <li className="lg:hidden">
                                    <DividerWide />
                                </li>
                            </>
                        )}
                    </Fragment>
                ))}
            </ul>
        </div>
    );
};

export default ListSection;
